var map = {
	"./A1.png": "3c3b",
	"./A2.png": "d07c",
	"./B1.png": "8101",
	"./B2.png": "0f14",
	"./C1.png": "d43e",
	"./C2.png": "cd4f",
	"./C3.png": "bed5",
	"./D.png": "9a86",
	"./E.png": "53ba",
	"./F1.png": "af2a",
	"./F2.png": "5f13",
	"./F3.png": "046f",
	"./G1.png": "4576",
	"./G2.png": "c9e3",
	"./G3.png": "e71a",
	"./G4.png": "f4b6",
	"./H.png": "1626"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c559";